const tokens = {
  RetryRefreshToken: Symbol(),
}

export { tokens as MiddlewareTokens }